import React, { useState, Fragment } from "react";
import {
  Paper,
  Typography,
  Menu,
  MenuItem,
  IconButton,
} from "@material-ui/core";
import classnames from "classnames";

// styles
import useStyles from "./styles";
import { MoreVert as MoreIcon } from "icons";

export default function Widget({
  children,
  title,
  noBodyPadding,
  bodyClass,
  menuItems,
  header,
  noHeaderPadding,
  headerClass,
  style,
  noWidgetShadow,
  button,
  ...props
}) {
  var classes = useStyles();
  var [moreButtonRef, setMoreButtonRef] = useState(null);
  var [isMoreMenuOpen, setMoreMenuOpen] = useState(false);

  const handleMenuItemOnClick = (onClick) => {
    onClick();
    setMoreMenuOpen(false);
  };

  return (
    <div className={classes.widgetWrapper} style={style && { ...style }}>
      <Paper
        className={classes.paper}
        classes={{
          root: classnames(classes.widgetRoot, {
            [classes.noWidgetShadow]: noWidgetShadow,
          }),
        }}
      >
        <div
          className={classnames(classes.widgetHeader, {
            [classes.noPadding]: noHeaderPadding,
            [headerClass]: headerClass,
          })}
        >
          {header ? (
            header
          ) : (
            <Fragment>
              <Typography variant="h5" color="textSecondary" noWrap>
                {title}
              </Typography>
              {props.helpText && (
                <span style={{ fontSize: "0.625rem" }}>{props.helpText}</span>
              )}
              {button && button}
              {menuItems && menuItems.length ? (
                <IconButton
                  color="primary"
                  classes={{ root: classes.moreButton }}
                  aria-owns="widget-menu"
                  aria-haspopup="true"
                  onClick={() => setMoreMenuOpen(true)}
                  buttonRef={setMoreButtonRef}
                >
                  <MoreIcon />
                </IconButton>
              ) : null}
            </Fragment>
          )}
        </div>
        <div
          className={classnames(classes.widgetBody, {
            [classes.noPadding]: noBodyPadding,
            [bodyClass]: bodyClass,
          })}
        >
          {children}
        </div>
      </Paper>
      <Menu
        id="widget-menu"
        open={isMoreMenuOpen}
        anchorEl={moreButtonRef}
        onClose={() => setMoreMenuOpen(false)}
        disableAutoFocusItem
      >
        {menuItems && menuItems.length
          ? menuItems.map((item, index) => (
              <MenuItem
                key={`menu_${index}`}
                onClick={() =>
                  item.onClick ? handleMenuItemOnClick(item.onClick) : null
                }
              >
                <Typography>{item.title}</Typography>
              </MenuItem>
            ))
          : null}
      </Menu>
    </div>
  );
}
